import store from '@/store';
import useSupplierStore from '@/store/modules/supplier';

const supplierStore = useSupplierStore(store);
export const factorySysConfigMap: Recordable = {
  miniProgramShowWashingMark: '洗水唛、标签打印模板',
};

export const getConfigValue = (configName: string) => {
  return supplierStore.configMap[configName];
};

export default getConfigValue;
